import { DeviceIdentificationType } from '../enums';

export interface IDeviceIdentificationObject {
    type: DeviceIdentificationType;
    value: string;
}
